export const DEFAULT_SLIDES_TO_SHOW = 2;
export const DEFAULT_AUTOPLAY_SPEED = 3000;
export const IS_HTML_ADVERTISEMENT_ENABLED = false;

export class AdvertisementType {
	static CARD = "card";
	static HTML = "html";
}

export class LinkType {
	static NONE = "none";
	static COURSE = "course";
	static CUSTOM = "custom";
}

export class PreviewMode {
	static STANDARD = "standard";
	static COMPACT = "compact";
}

export class PreviewPage {
	static STUDENT_DASHBOARD = "student-dashboard";
	static COURSE = "course";
}
